import { SupportedChainId } from '~/constants/chains'
import { ContactSendRule } from '~/types'
import { Address } from '~/utils/address'

/** The rules for one contact combine with OR. A null tokenAddress allows
 * all tokens on that chain. */
export const isAllowedBySendRules = ({
  sendRules,
  tokenAddress,
  chainId,
}: {
  sendRules: ContactSendRule[]
  tokenAddress: string
  chainId: SupportedChainId
}): boolean => {
  if (sendRules.length === 0) return true
  return sendRules.some(
    (rule) =>
      rule.chainId === chainId &&
      (rule.tokenAddress === null ||
        Address.equal(rule.tokenAddress, tokenAddress)),
  )
}

/** The chains that the rules allow. Null means no restriction. */
export const getSendRuleChainIds = (
  sendRules: ContactSendRule[],
): SupportedChainId[] | null => {
  if (sendRules.length === 0) return null
  return [...new Set(sendRules.map((rule) => rule.chainId))]
}
